import React from 'react'
import { styled } from '../../../../stitches.config'
import LinkButton from '../buttons/LinkButton'
import FAQSection from '../text/FAQSection'

const Section = styled('div', {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: '3rem 0',
    '@sm': {
        padding: '4rem 2rem',
    },
    '@md': {
        flexDirection: 'row',
    },
})

const LeftSideWrapper = styled('div', {
    maxWidth: '100%',
    '& h2': {
        marginBottom: '2rem',
    },
    '& .c-dpxHRI-HOwtc-variant-primaryOutline': {
        maxWidth: '16rem',
        marginBottom: '1.5rem',
    },
    '@md': {
        maxWidth: '35%',
        '& h2': {
            marginBottom: '3rem',
        },
    },
})

const RightSideWrapper = styled('div', {
    width: '100%',
    '@md': { width: '60%' },
})

const style = {
    faqPadding: { padding: '.45rem 0 .5rem' },
}

interface FAQProps {
    faqContent: object
    buttonUrl: string
}

const BrandFAQs = ({ faqContent, buttonUrl }: FAQProps) => {
    return (
        <Section>
            <LeftSideWrapper>
                <h2>Frequently asked questions</h2>
                <LinkButton
                    variant={'primaryOutline'}
                    label={'Get help'}
                    url={buttonUrl}
                    buttonWidth={'17rem'}
                    textTransform={'uppercase'}
                    data-testid={'helpButton'}
                />
            </LeftSideWrapper>
            <RightSideWrapper>
                {Object.values(faqContent).map((value, index) => {
                    return (
                        <div
                            key={index}
                            style={style.faqPadding}
                            data-testid={`faqQuestion${index}`}
                        >
                            <FAQSection
                                faqHeader={value.question}
                                faqText={value.answer}
                            />
                        </div>
                    )
                })}
            </RightSideWrapper>
        </Section>
    )
}

export default BrandFAQs
